module.exports = __STORYBOOK_MODULE_CLIENT_LOGGER__;